import options from './content.component';

export default {
    selector: 'dtLayoutContent',
    options
};
